var t = /* @__PURE__ */ ((e) => (e.valueOfField = "valueOfField", e.valueFromContext = "valueFromContext", e.actions = "actions", e))(t || {}), r = /* @__PURE__ */ ((e) => (e.setFieldValue = "setFieldValue", e.setComponentProps = "setComponentProps", e.setFieldError = "setFieldError", e.setFieldValidations = "setFieldValidations", e.triggerEvent = "triggerEvent", e))(r || {}), i = /* @__PURE__ */ ((e) => (e.onField = "onField", e))(i || {});
const n = [
  // Comparison
  "==",
  "===",
  "!=",
  "!==",
  ">",
  ">=",
  "<",
  "<=",
  // Logical
  "!",
  "!!",
  "and",
  "or",
  // Conditional
  "if",
  "?:",
  // Math
  "+",
  "-",
  "*",
  "/",
  "%",
  // Array
  "all",
  "none",
  "some",
  "filter",
  "map",
  "reduce",
  "merge",
  // String
  "cat",
  "substr",
  // Variable
  "var",
  // Utility
  "log",
  "in",
  // Counting/length
  "count",
  "size",
  "length",
  // Min/max
  "min",
  "max",
  // Missing
  "missing",
  "missing_some"
];
export {
  t as CUSTOM_OPERATORS_ENUM,
  r as INTERNAL_CUSTOM_OPERATORS_ENUM,
  n as JSON_LOGIC_OPERATORS,
  i as UTILITY_OPERATORS_ENUM
};
